import React from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import Cookies from 'universal-cookie';
import { parse } from 'date-fns';
// import { uploadFile } from '../../apis/s3';

export const hasNumbers = (t) => {
  const regex = /\d/g;
  return regex.test(t);
};
export const ErrorToast = (msg) => {
  toast.error(<div> {`${msg}`}</div>, {
    position: toast.POSITION.TOP_CENTER,
    hideProgressBar: true,
  });
};
export const MultipleErrorToast = (msg) => {
  toast.error(
    <>
      {msg.map((x) => (
        <div> {x}</div>
      ))}
    </>,
    {
      position: toast.POSITION.TOP_CENTER,
      hideProgressBar: true,
    },
  );
};
export const notifySuccess = (msg) => {
  toast.success(msg, {
    position: toast.POSITION.TOP_CENTER,
    hideProgressBar: true,
    style: { background: '#027A48' },
  });
};
export const nth = (d) => {
  if (d > 3 && d < 21) return 'th';
  switch (d % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};
export const containsObject = (obj, list) => {
  const contain = list.filter((item) => item === obj);
  if (contain?.length > 0) return true;
  return false;
};
export const ordinalDate = (dateStr) => {
  const dateVal = new Date(dateStr.replace(/-/g, '/'));
  const date = dateVal.getDate();
  const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][
    dateVal.getMonth()
  ];
  const ordinal = `${date} ${month} ${dateVal.getFullYear()}`;
  return ordinal;
};

export const getFilteredList = (list, input, keys = []) => {
  if (!input || keys.length === 0) return list;
  const lowercasedInput = input?.toLowerCase();
  return list?.filter((item) =>
    keys.some((key) => {
      const value = item[key];
      if (!value) return false;
      const valueStr = value?.toString()?.toLowerCase();
      return valueStr?.includes(lowercasedInput);
    }),
  );
};

export const filterAIRoleplayTopics = (topics = [], input = '') => {
  if (!input) return topics;
  const lowercasedInput = input.toLowerCase();
  const matches = (value) => value?.toString()?.toLowerCase()?.includes(lowercasedInput);
  return topics.filter(
    (topic) =>
      matches(topic.name) ||
      matches(topic.id) ||
      (topic.exercises || []).some((exercise) => matches(exercise.name) || matches(exercise.id)),
  );
};

/**
 * Format seconds as human-readable duration.
 * Under 1 min: seconds only (e.g. "45 secs").
 * 1 min or above: round to nearest minute, do not show seconds (e.g. "1 min", "2 mins", "12 mins").
 */
export const formatDurationSeconds = (sec) => {
  const e = Number(sec);
  const duration = moment.duration(e, 'seconds');

  if (e < 60) {
    const s = duration.seconds();
    return s ? `${s} ${s !== 1 ? 'secs' : 'sec'}` : '0 sec';
  }

  // Above 1 min: show only days / hours / minutes (no seconds)
  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  let minutes = duration.minutes() ?? 0;
  const seconds = duration.seconds();

  if (seconds >= 30) minutes += 1;
  

  const parts = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  if (minutes) parts.push(`${minutes} ${minutes > 1 ? 'mins' : 'min'}`);
  return parts.length ? parts.join(' ') : '0 sec';
};

// export const uploadInteractionsToS3 = (filesData, folderSuffix) => {
//   if (!filesData || !filesData.length) {
//     return {};
//   }
//   const BASE_URL =
//     process.env.REACT_APP_NODE_ENV === 'production' ? 'https://cdn.rocked.us' : 'https://cdn-staging.rocked.us';
//   const uploadPromises = [];
//   let finalUrl = `${BASE_URL}/interaction/`;
//   filesData.forEach((f) => {
//     const arrPath = f.webkitRelativePath.split('/');
//     const filePath = arrPath.reduce((acc, val, index) => {
//       let keys = '';
//       if (index === 0) {
//         keys = `${acc}${val}_${folderSuffix}`;
//       } else if (val === 'story.html' || val === 'index.html') {
//         keys = `${acc}/index.html`;
//         finalUrl += `${acc}/index.html`;
//       } else {
//         keys = `${acc}/${val}`;
//       }
//       return keys;
//     }, '');
//     uploadPromises.push(uploadFile(f, `interaction/${filePath}`, f.type));
//   });

//   return {
//     uploadPromises,
//     finalUrl,
//   };
// };

export const flattenFiles = (files) => {
  const flatFiles = [];

  for (let i = 0; i < files.length; i += 1) {
    const file = files[i];
    flatFiles.push({ file, uploadDir: file.webkitRelativePath });
  }

  return flatFiles;
};

export const searchArray = (mainArray = [], filters = [], searchKey = '') => {
  const search = searchKey.toLowerCase();
  return searchKey
    ? mainArray.filter((item) => filters.some((key) => item[key]?.toLowerCase().includes(search)))
    : mainArray;
};

export const searchEmployees = (employees = [], searchKey = '') => {
  const search = searchKey.toLowerCase();
  return searchKey
    ? employees.filter((item) => `${item.firstName} ${item.lastName}`?.toLowerCase().includes(search))
    : employees;
};

export const journeyFilter = (journeyArray = [], filterValue = '') => {
  let result = journeyArray;
  if (filterValue !== 'All') {
    if (filterValue !== 'Mandatory') {
      result = journeyArray?.filter((item) => item.journeyFrom?.indexOf(filterValue) > -1);
    } else {
      result = journeyArray?.filter((item) => item.mandatory === true);
    }
  }
  return result;
};

export const formatDate = (date) => {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join('-');
};

// Selected list should move up in the list
export function sortItemsBySelection(selectedItems, filterItems, itemKey) {
  return filterItems?.slice()?.sort((a, b) => {
    if (Array.isArray(selectedItems)) {
      const isSelectedA = selectedItems.includes(a[itemKey]);
      const isSelectedB = selectedItems.includes(b[itemKey]);

      if (isSelectedA && !isSelectedB) return -1;
      if (!isSelectedA && isSelectedB) return 1;
      return 0;
    }
    const isSelectedA = Object.hasOwnProperty.call(selectedItems, a[itemKey]);
    const isSelectedB = Object.hasOwnProperty.call(selectedItems, b[itemKey]);
    if (isSelectedA && !isSelectedB) return -1;
    if (!isSelectedA && isSelectedB) return 1;
    return 0;
  });
}

export const secondsToMinute = (seconds) => {
  const minutes = Math.ceil(seconds / 60);
  const formattedMinutes = moment.utc(minutes * 60 * 1000).format('m');
  const suffix = minutes > 1 ? 'mins' : 'min';

  return `${formattedMinutes} ${suffix}`;
};

export function formatTime(seconds) {
  const duration = moment.duration(seconds, 'seconds');
  const formattedTime = moment.utc(duration.asMilliseconds()).format('m : ss');
  return formattedTime;
}

// date formate Ex: 21 March 2023
export const formateDate = (date) => moment(date).format('D MMM, YYYY');

export const encryptAESJSONData = (data, key = 'RockED') =>
  encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(data), key).toString());

// Decryption
export const decryptAESData = (data, key = 'RockED') => {
  if (!data) return '';
  try {
    const decoded = decodeURIComponent(data);
    const bytes = CryptoJS.AES.decrypt(decoded, key);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    ErrorToast(err.message);
    return '';
  }
};

export const decryptAESJSONData = (data, key = 'RockED') => {
  if (!data) {
    return {};
  }
  try {
    const decoded = decodeURIComponent(data);
    const bytes = CryptoJS.AES.decrypt(decoded, key);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (err) {
    ErrorToast(err.message);
    return {};
  }
};

// Decryption for video link
export function decryptData(data) {
  const bytes = CryptoJS.AES.decrypt(data, process.env.REACT_APP_VIMEO_KEY);
  const originalData = bytes.toString(CryptoJS.enc.Utf8);
  return originalData;
}

export function generateVideoUrl(data) {
  const { id, res = '360p', meta, url = '' } = data;
  if (url) {
    return decryptData(decodeURIComponent(url));
  }
  const signature = decryptData(meta);
  const VIMEO_VIDEO_URL =
    'https://player.vimeo.com/progressive_redirect/playback/#id/rendition/#resolution?loc=external&signature=#signature';
  return VIMEO_VIDEO_URL.replace('#id', id).replace('#resolution', res).replace('#signature', signature);
}
export const getImageUrl = (imageSrc) => {
  if (imageSrc?.includes('https://cdn-staging.rocked.us/') || imageSrc?.includes('https://cdn.rocked.us/')) {
    const cookies = new Cookies();

    try {
      const url = new URL(imageSrc);

      const accessToken = cookies.get('access_token');
      const imageToken = cookies.get('media_token');

      if (accessToken && imageToken) {
        const params = url.searchParams;
        params.set('token', imageToken);
        return url.toString();
      }
    } catch (err) {
      console.log(err.message, imageSrc, typeof imageSrc);
    }
  }

  return imageSrc;
};

export const handleLogoutUser = () => {
  const cookies = new Cookies();
  cookies.remove('access_token');
  cookies.remove('auth_expires');
  cookies.remove('refresh_token');
  cookies.remove('media_token');
  window.location.pathname = '/';
};

export const parseDateString = (value, type) => {
  if (!value) return null;
  try {
    if (type === 'monthly') {
      if (value.includes('-') && value.length === 10) {
        const date = parse(value, 'yyyy-MM-dd', new Date());
        return date;
      }
      return parse(value, 'MMMM', new Date());
    }
    if (type === 'yearly') {
      if (value.includes('-') && value.length === 10) {
        const date = parse(value, 'yyyy-MM-dd', new Date());
        return date;
      }
      return parse(value, 'yyyy', new Date());
    }
    return parse(value, 'yyyy-MM-dd', new Date());
  } catch {
    return null;
  }
};
